import React from 'react';
import SemanticThemeEditor from '@/components/theme/SemanticThemeEditor';
import { useEventDetails } from './EventDetailsContext';
import type { ThemeTokens } from '@/types/theme';

type DesignTabProps = {
  onPreviewTokensChange: (tokens: ThemeTokens) => void;
};

const DesignTab: React.FC<DesignTabProps> = ({ onPreviewTokensChange }) => {
  const {
    themeSelection,
    normalizedTheme,
    themePresets,
    themeLoading,
    themeSaving,
    savePresetTheme,
    saveCustomTheme,
  } = useEventDetails();

  return (
    <div className="space-y-6">
      <SemanticThemeEditor
        themeSelection={themeSelection}
        normalizedTheme={normalizedTheme}
        presets={themePresets}
        loading={themeLoading}
        saving={themeSaving}
        onSavePreset={savePresetTheme}
        onSaveCustom={saveCustomTheme}
        onPreviewTokensChange={onPreviewTokensChange}
      />
    </div>
  );
};

export default DesignTab;
